<script lang="ts">
  import ShimmerBar from './ShimmerBar.svelte';

  // Espelha o layout real — cinco cartões e a grade de oito colunas — para a
  // tela não pular quando o dado chega. Só na PRIMEIRA carga: refetch mantém o
  // que está em tela.
  const CARTOES = 5;
  const COLUNAS = 7;
  // Larguras diferentes por linha: uma coluna de retângulos idênticos não se
  // parece com uma tabela de nomes de cliente.
  const NOMES = ['150px', '104px', '186px', '92px', '132px', '118px', '164px', '98px',
                 '142px', '110px', '176px', '96px'];
</script>

<div class="skeleton" aria-busy="true" aria-label="carregando custos">
  <div class="cards">
    {#each Array(CARTOES) as _, i (i)}
      <div class="card">
        <ShimmerBar width="58%" height={12} />
        <ShimmerBar width="70%" height={32} />
        <ShimmerBar width="40%" height={12} />
      </div>
    {/each}
  </div>

  <div class="tabs">
    <ShimmerBar width="86px" height={16} />
    <ShimmerBar width="98px" height={16} />
    <ShimmerBar width="84px" height={16} />
  </div>

  <div class="filters">
    <ShimmerBar width="340px" height={34} />
    <ShimmerBar width="104px" height={28} />
    <ShimmerBar width="112px" height={28} />
    <ShimmerBar width="96px" height={28} />
  </div>

  <div class="table">
    <div class="row head">
      <ShimmerBar width="120px" height={11} />
      {#each Array(COLUNAS) as _, coluna (coluna)}
        <ShimmerBar width="64px" height={11} />
      {/each}
    </div>
    {#each NOMES as largura, linha (linha)}
      <div class="row">
        <div class="name">
          <ShimmerBar width={largura} height={15} />
          <ShimmerBar width="210px" height={11} />
        </div>
        {#each Array(COLUNAS) as _, coluna (coluna)}
          {#if coluna === COLUNAS - 1}
            <div class="total">
              <ShimmerBar width="86px" height={15} />
              <ShimmerBar width="110px" height={10} />
              <ShimmerBar width="96px" height={6} />
            </div>
          {:else}
            <ShimmerBar width="58px" height={14} />
          {/if}
        {/each}
      </div>
    {/each}
  </div>
</div>

<style>
  .skeleton {
    display: flex;
    flex-direction: column;
    gap: var(--space-5);
  }
  .cards {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
    gap: var(--space-4);
  }
  .card {
    background: var(--bg-elevated);
    border: 1px solid var(--border-subtle);
    border-radius: var(--radius-md);
    padding: var(--space-4);
    display: flex;
    flex-direction: column;
    gap: var(--space-3);
  }
  /* As abas e os filtros não dependem do dado, mas o esqueleto tem de reservar a
     altura deles: sem isso a tabela nasce 120px acima e desce quando o dado chega. */
  .tabs {
    display: flex;
    align-items: center;
    gap: var(--space-5);
    min-height: 34px;
    padding-bottom: var(--space-3);
    border-bottom: 1px solid var(--border-subtle);
  }
  .filters {
    display: flex;
    align-items: center;
    gap: var(--space-3);
    flex-wrap: wrap;
  }
  .table {
    border: 1px solid var(--border-subtle);
    border-radius: var(--radius-md);
    overflow: hidden;
  }
  /* A primeira coluna cresce e as sete de número ficam à direita, como na grade
     real — é o que impede a tela de pular quando o dado chega. */
  /* Alturas conferidas contra a tela cheia no navegador: cartão 117px, aba 34px,
     linha 85px. Sem isso o conteúdo desce de uma vez quando o dado chega. */
  .row {
    display: grid;
    grid-template-columns: minmax(180px, 1fr) repeat(7, max-content);
    align-items: center;
    gap: var(--space-4);
    padding: var(--space-4);
    border-bottom: 1px solid var(--border-subtle);
  }
  .row:last-child {
    border-bottom: none;
  }
  .row.head {
    background: var(--bg-elevated);
  }
  .name {
    display: flex;
    flex-direction: column;
    gap: var(--space-3);
  }
  /* A célula do total tem três alturas na tabela real — real, dólar e barra. */
  .total {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 5px;
  }
</style>
